"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";
import { cn } from "@repo/ui/lib/utils";
import Icon from "@repo/ui/components/ui/icon/icon";
import { NotificationsPageProps } from "./notifications-type";
import { useNotificationToggle } from "./notifications-icon";

export default function Notifications({
  notificationsUrl,
  children,
  className,
}: NotificationsPageProps & {
  className?: string;
  children: React.ReactNode;
}) {
  const t = useTranslations("Notifications");
  const notificationToggle = useNotificationToggle();

  return (
    <div className={className}>
      <div className="@container flex justify-between items-center text-primary-black dark:text-primary-white">
        <h1 className="text-[18px] @[678px]:text-[40px]">{t("title")}</h1>
        {notificationsUrl && (
          <Link
            href={notificationsUrl}
            rel="noopener noreferrer"
            onClick={() => {
              if (notificationsUrl && notificationToggle?.setIsToggled) {
                notificationToggle.setIsToggled(false);
              }
            }}
            className="underline underline-offset-4"
          >
            <div className="flex items-center gap-2">
              {t("view-all")}
              <Icon
                className={cn(
                  "h-4 w-4 stroke-primary-white dark:stroke-primary-black rounded-full bg-secondary-black dark:bg-primary-white p-1",
                )}
                icon="Arrow"
              />
            </div>
          </Link>
        )}
      </div>
      {children}
    </div>
  );
}
